/** X Ads Events Manager pixel ID for the muggle-ai.com website tag. */
export const X_PIXEL_ID = "rcded";
